<template>
  <div id="vue-app">
    <NavigationHeader />
    
    <main role="main">
      <RouterView />
    </main>
    
    <!-- Global UI Components -->
    <LoadingSpinner
      :visible="uiStore.loading"
      :message="uiStore.loadingMessage"
      :subtext="uiStore.loadingSubtext"
    />
    
    <CustomDialog
      :visible="uiStore.dialogVisible"
      :title="uiStore.dialogConfig.title"
      :message="uiStore.dialogConfig.message"
      :type="uiStore.dialogConfig.type"
      :is-danger="uiStore.dialogConfig.isDanger"
      :confirm-text="uiStore.dialogConfig.confirmText"
      :cancel-text="uiStore.dialogConfig.cancelText"
      @confirm="uiStore.closeDialog(true)"
      @cancel="uiStore.closeDialog(false)"
    />

    <NavigationFooter />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import NavigationHeader from './components/NavigationHeader.vue';
import NavigationFooter from './components/NavigationFooter.vue';
import LoadingSpinner from './components/LoadingSpinner.vue';
import CustomDialog from './components/CustomDialog.vue';
import { useUiStore } from './stores/uiStore';
import { useThemeStore } from './stores/themeStore';

const uiStore = useUiStore();
const themeStore = useThemeStore();

// Initialize theme on mount
onMounted(() => {
  themeStore.applyTheme();
});
</script>

<style lang="scss">
  @use '../styles/variables' as *;

// Import global styles from project root
@import '../styles/main.scss';


#vue-app {
  height: 100vh;
  display:flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;

  main[role="main"] {
    display: flex;
    flex: 1 0 auto;
    width: 100%;
    max-width: $container-max-width;
    padding-top: 2rem;
    justify-content: center;

    & > div{
      display: flex ;
      flex-direction: column;
      flex: 0 0 auto;
      width: 100%;
    }
    
    // background: var(--app-bg);
  }
}
// Responsive Design
@media (max-width: $breakpoint-sm) {
 #vue-app { 
  
    main[role="main"] {   
    padding-top: 1rem;
    
  .container {
    header{
      margin-bottom: 1rem;
    }
  }
  }
  
}
}
</style>
